module.exports = __webpack_public_path__ + "img/mundi-play-logo-rodape.78858454.png";